export default function () {
    function addHoverToggle(triggerSelector, containerSelector) {
        let timer;

        // Hover handling
        $(triggerSelector).on('mouseenter', () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                $(triggerSelector).addClass('is-hovered');
                $(containerSelector).stop(true, true).slideDown();
            }, 200);
        });

        $(triggerSelector).on('mouseleave', () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                $(triggerSelector).removeClass('is-hovered');
                $(containerSelector).stop(true, true).slideUp();
            }, 200);
        });

        $(containerSelector).on('mouseenter', () => {
            clearTimeout(timer);
        });

        $(containerSelector).on('mouseleave', () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                $(triggerSelector).removeClass('is-hovered');
                $(containerSelector).stop(true, true).slideUp();
            }, 200);
        });

        // Tap/click handling for mobile
        $(triggerSelector).on('click touchstart', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if ($(containerSelector).is(':visible')) {
                $(triggerSelector).removeClass('is-hovered');
                $(containerSelector).stop(true, true).slideUp();
            } else {
                $(triggerSelector).addClass('is-hovered');
                $(containerSelector).stop(true, true).slideDown();
            }
        });

        // Close when tapping outside
        $(document).on('click touchstart', (e) => {
            if (!$(e.target).closest(triggerSelector).length &&
                !$(e.target).closest(containerSelector).length) {
                $(containerSelector).stop(true, true).slideUp();
            }
        });
    }

    addHoverToggle('.main-account-toggle', '.main-account-toggle-container');
    addHoverToggle('.main-contact-toggle', '.main-contact-toggle-container');
    addHoverToggle('.sticky-account-toggle', '.sticky-account-toggle-container');
    addHoverToggle('.sticky-contact-toggle', '.sticky-contact-toggle-container');
}
